<ion-item-divider sticky="fixed" class="ion-no-border" mode="md">
  <div class="flex flex-col w-100">
    <div class="top-line">
      <div class="div-line"></div>
    </div>
    <ion-row class="pt-24 pb-4">
      <ion-col size="10" sizeXl="9" class="ion-align-self-center">
        <ion-text class="lbl-bold-18">{{listData.transaction.transaction_no}}</ion-text>
      </ion-col>
      <ion-col size="2" sizeXl="3" class="ion-text-center">
        <ion-icon [src]="'ic_close_ro' | getImagePipe" (click)="closeModal()" class="ft-36"></ion-icon>
      </ion-col>
    </ion-row>
  </div>
</ion-item-divider>
<ion-content>
  <hr class="divider1 w-100" />
  <div class="flex flex-col p-16">
    <ng-container *ngIf="listData.transaction.tr_dateo">
    <ion-item lines="none" >
      <ion-icon slot="start"  class="mr-8" [src]="'date_bl' | getImagePipe"></ion-icon>
      <ion-text class="lbl-14">{{'lbl_led_trans_date' | getLanguagePipe}} :&nbsp;{{listData.transaction.tr_dateo | dynamicDateTimePipe}}</ion-text>
    </ion-item>
    </ng-container>
    <ng-container *ngIf="listData.transaction.chequecleardate">
    <ion-item lines="none" class="mt-12">
      <ion-icon slot="start" class="mr-8" [src]="'date_bl' | getImagePipe"></ion-icon>
      <ion-text class="lbl-14">{{'lbl_tras_cler_date' | getLanguagePipe}} :&nbsp;{{listData.transaction.chequecleardate | dynamicDateTimePipe}}</ion-text>
    </ion-item>
    </ng-container>
    <ng-container *ngIf="listData.transaction.amount_old_symbol">
    <ion-item lines="none" class="mt-12">
      <ion-icon slot="start" class="mr-8" [src]="'rs_bl' | getImagePipe"></ion-icon>
      <ion-text class="lbl-14">{{'lbl_tra_amt' |getLanguagePipe}} :&nbsp;{{listData.transaction.amount_old_symbol}}</ion-text>
    </ion-item>
    </ng-container>
  </div>
</ion-content>